import { alpha } from '@material-ui/core/styles';
// ----------------------------------------------------------------------
export const Backdrop = ({ theme }) => {
    return {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: alpha(theme.palette.grey[900], 0.72)
                }
            }
        }
    };
};
//# sourceMappingURL=Backdrop.js.map